import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deactivateContractTemplate = (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.contractTemplate.deactivate.url, null))
    .patch<never, IdsInput>({ ids })
}
